import clsx from 'clsx'
import React, { CSSProperties, FC, ReactElement } from 'react'
import ModalDefault from 'react-modal'
import ReactModal from 'react-modal'

import styles from './styles.module.scss'

const customStyles = {
  content: {
    padding: 0,
    margin: 0,
    inset: 0,
    borderRadius: 0,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    border: 'none',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  overlay: {
    pointerEvents: 'auto' as const,
    background: 'transparent',
    border: 'none',
    zIndex: 99999,
  },
  portal: {
    zIndex: 999,
  },
}

interface IMobileCustomkPage {
  navBar: ReactElement
  Footer?: ReactElement
  style?: CSSProperties
  isModal?: boolean
  isOpen?: boolean
  styleChildren?: CSSProperties
  children: React.ReactNode
}

const MobileCustomPage: FC<IMobileCustomkPage> = ({
  children,
  navBar,
  Footer,
  style = {},
  isModal = false,
  isOpen = true,
}) => {
  if (isModal) {
    if (typeof window !== 'undefined') {
      ReactModal.setAppElement('body')
    }
    return (
      <ModalDefault isOpen={isOpen} style={customStyles}>
        <div className={clsx(styles.containerPage)} style={style}>
          {navBar}
          <div className={styles.containerChildren}>{children}</div>
          {Footer}
        </div>
      </ModalDefault>
    )
  }

  return (
    <div className={clsx(styles.containerPage)} style={style}>
      {navBar}
      <div className={styles.containerChildren}>{children}</div>
      {Footer}
    </div>
  )
}

export default MobileCustomPage
